import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import NotificationBar from "@components/NotificationBar/index";
import BreakupBox from "@components/Audit/breakup-box";
import "./uploaded-details.scss";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
	getVendorFilterLegislation,
	submitVendorCheckpointTasks,
	vendorCheckpointDocumentlist,
	vendorDeleteCheckpointLocationCommnets,
	vendorDeleteCheckpointLocationFile,
	vendorGetCheckpointInfoBySpecificLocation,
	vendorGetCheckpointLocationDashboardInfo,
} from "@services/checkpoint.service";
import qs from "query-string";
import moment from "moment";
import { getValue } from "@utils/lodash";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import PaginationPage from "@components/pagination/pagination";
import Header from "@components/common/Header";
import {
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Modal,
	ModalBody,
} from "reactstrap";
import CommentsModal from "./Modal/comments";
import { useParams } from "react-router-dom";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import UploadModal from "./Modal/upload";
import InputField from "@_common/InputRuleFeild";
import { formatText } from "@_common/text-helper";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { handleS3FileDownloadOnClick } from "@_common/s3-downloadfile";
import ReactTooltip from "react-tooltip";
import { QueryRequestHelper } from "@_common/query-request-helper";
import SearchableDropdownSelect from "@_common/SearchableDropdown";

interface IDashboardCheckPointDetailsProps {}

export const DashboardCheckPointDetails: React.FunctionComponent<
	IDashboardCheckPointDetailsProps
> = (props) => {
	let navigate = useNavigate();
	let mainParams = useParams();
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */

	const [isLoading, setIsLoading] = useState(false);
	const [locations, setLocations] = useState([]);
	const [filteredLegislation, setFilteredLegislation] = useState([]);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length === 0) {
			getData();
			getDashboardInfo();
			setDate(new Date());
			getFilterLegislations("", "");
		}
	}, []);

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length > 0) {
			getData();
			getDashboardInfo();
			if (params.search_text) {
				setSearchInput(params.search_text);
				setShowSearchTextbox(true);
			}
			if (params.page_no) {
				setPage_no(parseInt(params.page_no));
			}
			if (params.limit) {
				setLimit(parseInt(params.limit));
			}
			if (params.date) {
				setDate(new Date(params.date));
			} else {
				setDate(new Date());
			}
			if (params.legislation_id) {
				getFilterLegislations(params.legislation_id, "");
			} else {
				getFilterLegislations("", "");
			}
		}
	}, [window.location.href]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const [searchLoading, setSearchLoading] = useState(false);
	const getFilterLegislations = async (id: string, value: string) => {
		let payload: any = {
			legislation_id: id,
			search_text: value,
			page_no: 1,
			page_size: 10,
		};
		let queryRequest = QueryRequestHelper(payload);

		try {
			setSearchLoading(true);
			let resp = await getVendorFilterLegislation(queryRequest);
			if (resp) {
				setFilteredLegislation(
					getValue(resp, `data`, []).map((item: any) => ({
						...item,
						value: getValue(item, `legislation_name`, ""),
						label: getValue(item, `legislation_name`, ""),
					}))
				);
				setSearchLoading(false);
			} else {
				setSearchLoading(false);
			}
		} catch (error) {
			setSearchLoading(false);
		}
	};

	const [dashboardInfo, setDashboardInfo] = useState({});
	const [dashboardLoading, setDashboardLoading] = useState(false);
	const getDashboardInfo = async () => {
		let payload: any = {
			location_id: mainParams.id,
			month: mainParams.date ? parseInt(mainParams.date.split("-")[1]) : "",
			year: mainParams.date ? parseInt(mainParams.date.split("-")[0]) : "",
			vendor_id: "",
			type: "SUMMERY",
		};

		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		try {
			setDashboardLoading(true);
			let resp = await vendorGetCheckpointLocationDashboardInfo(payload);
			if (resp) {
				setDashboardLoading(false);
				setDashboardInfo(getValue(resp, `data`, ""));
			} else {
				setDashboardLoading(false);
			}
		} catch (error) {
			setDashboardLoading(false);
		}
	};

	const getData = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let dates = date ? date : new Date();

		let payload: any = {
			page_no: params.page_no ? parseInt(params.page_no) : 1,
			page_size: params.limit ? parseInt(params.limit) : 100,
			search_text: params.search_text,
			status: params.status,
			sort_by: params.sort_by,
			upload_status: mainParams.status === "-" ? "" : mainParams.status,
			audit_status: mainParams.audit === "-" ? "" : mainParams.audit,
			is_submitted: params.is_submitted,
			location_id: mainParams.id,
			month: mainParams.date ? mainParams.date.split("-")[1] : "",
			year: mainParams.date ? mainParams.date.split("-")[0] : "",
			is_active: true,
		};

		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		setIsLoading(true);
		try {
			let resp = await vendorGetCheckpointInfoBySpecificLocation(queryRequest);
			if (resp) {
				setIsLoading(false);
				setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
				setTotalCount(getValue(resp, `data.pagination.total`, 0));
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};

	const getDataRefetch = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
			page_no: params.page_no ? parseInt(params.page_no) : 1,
			page_size: params.limit ? parseInt(params.limit) : 100,
			search_text: params.search_text,
			status: params.status,
			sort_by: params.sort_by,
			upload_status: mainParams.status === "-" ? "" : mainParams.status,
			audit_status: mainParams.audit === "-" ? "" : mainParams.audit,
			is_submitted: params.is_submitted,
			location_id: mainParams.id,
			month: mainParams.date ? mainParams.date.split("-")[1] : "",
			year: mainParams.date ? mainParams.date.split("-")[0] : "",
			is_active: true,
		};

		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		try {
			let resp = await vendorGetCheckpointInfoBySpecificLocation(queryRequest);
			if (resp) {
				setIsLoading(false);
				setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
				setTotalCount(getValue(resp, `data.pagination.total`, 0));
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                                 Delete section                             */
	/* -------------------------------------------------------------------------- */
	const [deleteObj, setDeleteObj] = useState({
		taskId: "",
		id: "",
	});

	const [isDelete, setIsDelete] = useState(false);
	const handleDelete = () => {
		setIsDelete(!isDelete);
	};

	const handleDeleteFunction = async () => {
		try {
			let resp = await vendorDeleteCheckpointLocationFile(
				deleteObj.taskId,
				deleteObj.id
			);
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				handleDelete();
				getDataRefetch();
				getDashboardInfo();
			}
		} catch (error) {}
	};

	const handleDeleteFile = async (taskId: string, id: string) => {
		setDeleteObj({
			...deleteObj,
			taskId: taskId,
			id: id,
		});
		handleDelete();
	};

	const [comments, setComments] = useState("");
	const [submitLoading, setSubmitLoading] = useState(false);
	const handleSubmitTask = async () => {
		try {
			if (comments) {
				setSubmitLoading(true);
				let payload = {
					ids: selectedIndex,
					audit_status: "PENDING_AUDIT",
					commentsInfo: {
						comments: comments,
						type: "SUBMISSION_COMMENT",
					},
				};
				let resp = await submitVendorCheckpointTasks(payload);
				if (resp) {
					setSubmitLoading(false);
					toast.success("Submitted successfully");
					handleModal2();
					setComments("");
					getDataRefetch();
					setSelectedIndex([]);
				}
			} else {
				toast.error("Please add comments");
				setSubmitLoading(false);
			}
		} catch (error) {
			setSubmitLoading(false);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Pagination section                           */
	/* -------------------------------------------------------------------------- */

	const [totalCount, setTotalCount] = useState(0);
	const [limit, setLimit] = useState(100);
	const [page_no, setPage_no] = useState(1);

	const handleChangePagination = (page_no: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
			...params,
			page_no: page_no,
		};
		const queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const handleChangeLimit = (limit: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload = {
			...params,
			limit: limit,
			page_no: 1,
		};
		const queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	/* -------------------------------------------------------------------------- */
	/*                               Search section                               */
	/* -------------------------------------------------------------------------- */
	const [showSearchTextbox, setShowSearchTextbox] = useState(false);
	const [search_text, setSearchInput] = useState<any>("");

	const toggleSearch = () => {
		setShowSearchTextbox((prevState) => !prevState);
	};
	const toggleSearchClose = () => {
		setSearchInput("");
		toggleSearch();
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (params.search_text) {
			delete params.search_text;
			let payload: any = { ...params };
			// removing null values
			Object.keys(payload).forEach((key) => {
				if (!payload[key] || payload[key] === undefined) {
					delete payload[key];
				}
			});
			let queryRequest = qs.stringify(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
			getData();
		}
	};

	const handleChangeSearch = async (e: any) => {
		setSearchInput(e.target.value);
		let payload: any = {
			search_text: e.target.value,
		};
		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
		if (!e.target.value) {
			getData();
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */
	const [isOpen, setIsOpen] = useState(false);
	const handleModal = () => {
		setIsOpen(!isOpen);
	};
	const [isOpen1, setIsOpen1] = useState(false);
	const handleModal1 = () => {
		setIsOpen1(!isOpen1);
	};

	const [isOpen2, setIsOpen2] = useState(false);
	const handleModal2 = () => {
		setIsOpen2(!isOpen2);
	};

	const [vendorInfo, setVendorInfo] = useState({});
	const handleModalComment = (obj: object) => {
		setVendorInfo(obj);
		handleModal();
	};
	const handleModalCommentCancel = () => {
		setVendorInfo({});
		handleModal();
	};

	const handleModalUpload = (obj: object) => {
		setVendorInfo(obj);
		handleModal1();
	};
	const handleModalUploadCancel = () => {
		setVendorInfo({});
		handleModal1();
	};

	const handleUpdateStatus = (update_status: string) => {
		setSelectedIndex([]);
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		params.update_status = update_status;
		Object.keys(params).forEach((key) => {
			if (!params[key] || params[key] === undefined) {
				delete params[key];
			}
		});
		let queryRequest = qs.stringify(params);
		navigate(`${window.location.pathname}?${queryRequest}`);
		if (!update_status) {
			getData();
		}
	};
	const handleUpdateAuditStatus = (update_status: string) => {
		if (update_status) {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			params.is_submitted =
				update_status === "SUBMITTED"
					? "true"
					: update_status === "NOT_SUBMITTED"
					? "false"
					: "";
			Object.keys(params).forEach((key) => {
				if (!params[key] || params[key] === undefined) {
					delete params[key];
				}
			});
			let queryRequest = qs.stringify(params);
			navigate(`${window.location.pathname}?${queryRequest}`);
			if (!update_status) {
				getData();
			}
		} else {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			delete params.is_submitted;
			Object.keys(params).forEach((key) => {
				if (!params[key] || params[key] === undefined) {
					delete params[key];
				}
			});
			let queryRequest = qs.stringify(params);
			navigate(`${window.location.pathname}?${queryRequest}`);
			if (!update_status) {
				getData();
			}
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Date section                                 */
	/* -------------------------------------------------------------------------- */

	const [date, setDate] = useState<Date | null>(null);
	const handleSubmitDate = () => {
		let dates = moment(date).format("YYYY-MM-DD");
		let payload: any = {
			date: dates,
		};
		// removing null values
		Object.keys(payload).forEach((key) => {
			if (!payload[key] || payload[key] === undefined) {
				delete payload[key];
			}
		});
		let queryRequest = qs.stringify(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	/* -------------------------------------------------------------------------- */
	/*                               Checkbox Section                             */
	/* -------------------------------------------------------------------------- */

	const [selectedIndex, setSelectedIndex] = useState<any>([]);

	const handleChangeCheckbox = (id: String) => {
		let selected = selectedIndex.filter((item: string) => item === id);
		if (getValue(selected, `length`, 0) === 0) {
			selectedIndex.push(id);
			setSelectedIndex([...selectedIndex]);
		} else {
			let selected = selectedIndex.filter((item: string) => item !== id);
			setSelectedIndex(selected);
		}
	};

	const [all, setAll] = useState("false");
	const handleChangeAllLocations = (value: string) => {
		setAll(value);
		if (value === "true") {
			let loc = locations.map((item: object) => getValue(item, `id`, ""));
			setSelectedIndex(loc);
		} else {
			setSelectedIndex([]);
		}
	};

	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());
	let enableCopy: any =
		getValue(selectedIndex, `length`, 0) === 1
			? getValue(locations, `length`, 0) > 0 &&
			  locations.filter(
					(item: object) =>
						getValue(item, `id`, "") === getValue(selectedIndex, `[${0}]`, "")
			  )
			: [];

	const [Compliance, setCompliance] = useState(true);
	const toggleCompliance = () => {
		setCompliance(!Compliance);
	};

	const selectedIDforCheckpoint = locations.filter(
		(item) =>
			selectedIndex.length > 0 && selectedIndex[0] === getValue(item, `id`, "")
	);

	let selectedCheck = locations.filter((item) => {
		if (selectedIndex.includes(getValue(item, `id`, ""))) return item;
	});
	let checkUploaded: any =
		getValue(selectedCheck, `length`, 0) > 0 &&
		selectedCheck.filter((item: any) => {
			if (getValue(item, `upload_status`, "") === "NOT_UPLOADED") return item;
		});

	const handleUploadDocument = () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		params.vendor_checkpoint_ids = selectedIndex;
		Object.keys(params).forEach((key) => {
			if (!params[key] || params[key] === undefined) {
				delete params[key];
			}
		});
		let queryRequest = qs.stringify(params);
		navigate(
			`/checkpoint/details/bulk-upload/${mainParams.id}/${mainParams.date}/${mainParams.code}?${queryRequest}`
		);
	};

	let checkSubmit: any =
		getValue(selectedCheck, `length`, 0) > 0 &&
		selectedCheck.filter((item: any) => !getValue(item, `is_submitted`, ""));

	/* -------------------------------------------------------------------------- */
	/*                      New Location Search Section                           */
	/* -------------------------------------------------------------------------- */

	const handleTriggerAPI = async (value: string) => {
		console.log(value);
		if (!value) {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			delete params.legislation_id;
			let payload = {
				...params,
				page_no: 1,
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		} else {
			getFilterLegislations("", value);
		}
	};
	const handleChangeFilter = (name: string, value: string) => {
		setSelectedIndex([]);
		if (value) {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			let payload = {
				...params,
				[name]: value,
				page_no: 1,
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		} else {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			let payload = {
				...params,
				[name]: "",
				page_no: 1,
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Sticky Header Section                        */
	/* -------------------------------------------------------------------------- */

	const [sticky, setSticky] = useState("");
	// on render, set listener
	useEffect(() => {
		window.addEventListener("scroll", isSticky);
		return () => {
			window.removeEventListener("scroll", isSticky);
		};
	}, []);

	const isSticky = () => {
		/* Method that will fix header after a specific scrollable */
		const scrollTop = window.scrollY;
		const stickyClass = scrollTop >= 250 ? "is-sticky" : "";
		setSticky(stickyClass);
	};
	const classes = `${sticky}`;
	return (
		<>
			<Header />
			<div className="checkpoint-wrapper position-relative">
				<div className="uploaded-details-wrapper uploaded-details-wrapper--checkpoint">
					<div className="sub-header d-flex align-items-center justify-content-between">
						{/* <div className="checkpoints-timer-wrapper d-flex align-items-center">
							<img src="/images/purple-awesome.svg" className="img-fluid" />
							{dashboardLoading ? (
								<p className="mx-2">Please wait...</p>
							) : (
								<p className="mx-2">
									{getValue(dashboardInfo, `releaseInfo.days`, "")}{" "}
									{getValue(dashboardInfo, `releaseInfo.msg`, "")}
								</p>
							)}
						</div> */}
					</div>
					<div className="dashboard-compliance dashboard-compliance__checkpoint-wrapper">
						<div className="dashboard-compliance__common dashboard-compliance__common-checkpoint d-flex align-items-center justify-content-between">
							<h3 className="dashboard-compliance__title">Activity</h3>
							<h3 className="dashboard-compliance__date dashboard-compliance__date--compliance overview-wrapper__header-date d-flex align-items-center">
								<img
									src="/images/arrow-drop.svg"
									className="img-fluid cursor-pointer"
									onClick={toggleCompliance}
								/>
							</h3>
						</div>
						<div
							className={`d-flex align-items-center mb-3 justify-content-between ${
								Compliance
									? "dashboard-compliance__checkpoint-breakup active"
									: "dashboard-compliance__checkpoint-breakup"
							}`}
						>
							{/* {breakupAuditnewArray.map((breakupAuditObj, index) => {
								return <BreakupBox auditScore={breakupAuditObj} key={index} />;
							})} */}
							<section className="breakup-box">
								<div className="breakup-box__details">
									<h6 className="breakup-box__title">
										{getValue(dashboardInfo, `summery.uploaded_count`, "0")}
									</h6>
									<p className="breakup-box__text">{"Uploaded"}</p>
								</div>
								<img
									src={`/images/upload-image.svg`}
									className="img-fluid breakup-box-image"
								/>
							</section>
							&nbsp;&nbsp;
							<section className="breakup-box">
								<div className="breakup-box__details">
									<h6 className="breakup-box__title">
										{getValue(dashboardInfo, `summery.not_uploaded_count`, "0")}
									</h6>
									<p className="breakup-box__text">{"Not Uploaded"}</p>
								</div>
								<img
									src={`/images/not-uploaded-image.svg`}
									className="img-fluid breakup-box-image"
								/>
							</section>
							&nbsp;&nbsp;
							<section className="breakup-box">
								<div className="breakup-box__details">
									<h6 className="breakup-box__title">
										{getValue(
											dashboardInfo,
											`summery.pending_audit_count`,
											"0"
										)}
									</h6>
									<p className="breakup-box__text">{"Pending Audit"}</p>
								</div>
								<img
									src={`/images/upload-image.svg`}
									className="img-fluid breakup-box-image"
								/>
							</section>
							&nbsp;&nbsp;
							<section className="breakup-box">
								<div className="breakup-box__details">
									<h6 className="breakup-box__title">
										{getValue(dashboardInfo, `summery.complied_count`, "0")}
									</h6>
									<p className="breakup-box__text">{"Compiled"}</p>
								</div>
								<img
									src={`/images/chk-circle-green.svg`}
									className="img-fluid breakup-box-image"
								/>
							</section>
							&nbsp;&nbsp;
							<section className="breakup-box">
								<div className="breakup-box__details">
									<h6 className="breakup-box__title">
										{getValue(dashboardInfo, `summery.non_complied_count`, "0")}
									</h6>
									<p className="breakup-box__text">{"Non-Complied"}</p>
								</div>
								<img
									src={`/images/upload-image.svg`}
									className="img-fluid breakup-box-image"
								/>
							</section>
							&nbsp;&nbsp;
							<section className="breakup-box">
								<div className="breakup-box__details">
									<h6 className="breakup-box__title">
										{getValue(
											dashboardInfo,
											`summery.partially_complied_count`,
											"0"
										)}
									</h6>
									<p className="breakup-box__text">{"Partially Complied"}</p>
								</div>
								<img
									src={`/images/flaky.svg`}
									className="img-fluid breakup-box-image"
								/>
							</section>
							&nbsp;&nbsp;
							<section className="breakup-box">
								<div className="breakup-box__details">
									<h6 className="breakup-box__title">
										{getValue(
											dashboardInfo,
											`summery.not_applicable_count`,
											"0"
										)}
									</h6>
									<p className="breakup-box__text">{"Not Applicable"}</p>
								</div>
								<img
									src={`/images/upload-image.svg`}
									className="img-fluid breakup-box-image"
								/>
							</section>
							{/* &nbsp;&nbsp;
							<section className="breakup-box">
								<div className="breakup-box__details">
									<h6 className="breakup-box__title">
										{getValue(
											dashboardInfo,
											`summery.send_back_to_vendor_count`,
											"0"
										)}
									</h6>
									<p className="breakup-box__text">{"Sent Back to Vendor"}</p>
								</div>
								<img
									src={`/images/upload-image.svg`}
									className="img-fluid breakup-box-image"
								/>
							</section> */}
						</div>
					</div>
					<div className="uploaded-details-wrapper__header-checkpoint mt-4">
						<div className="d-flex align-items-center mb-3">
							<NavLink to={`/dashboard?date=${mainParams.date}`}>
								<img src="/images/back-arrow.svg" className="img-fluid " />
							</NavLink>
							<p className="uploaded-details-wrapper__date px-2">
								{moment(new Date(mainParams.date)).format("MMM, YYYY")}
							</p>
						</div>
						<div className="d-flex align-items-center justify-content-between mt-4">
							<div className="d-flex">
								<div className="uploaded-details-wrapper__dropdown-button">
									<h6 className="uploaded-details-wrapper__dropdown-title">
										Update Status
									</h6>
									<UncontrolledDropdown className="uploaded-details-wrapper-dropdown">
										<DropdownToggle caret>
											{params.update_status == "UPLOADED"
												? "Uploaded"
												: params.update_status == "NOT_UPLOADED"
												? "Not Uploaded"
												: "All"}
										</DropdownToggle>
										<DropdownMenu>
											<DropdownItem onClick={() => handleUpdateStatus("")}>
												<p>All</p>
											</DropdownItem>
											<DropdownItem
												onClick={() => handleUpdateStatus("UPLOADED")}
											>
												Uploaded
											</DropdownItem>
											<DropdownItem
												onClick={() => handleUpdateStatus("NOT_UPLOADED")}
											>
												Not Uploaded
											</DropdownItem>
										</DropdownMenu>
									</UncontrolledDropdown>
								</div>
								<div className="uploaded-details-wrapper__dropdown-button">
									<h6 className="uploaded-details-wrapper__dropdown-title">
										Submit Status
									</h6>
									<UncontrolledDropdown className="uploaded-details-wrapper-dropdown">
										<DropdownToggle caret>
											{params.is_submitted == "true"
												? "Submitted"
												: params.is_submitted == "false"
												? "Not Submitted"
												: "All"}
										</DropdownToggle>
										<DropdownMenu>
											<DropdownItem onClick={() => handleUpdateAuditStatus("")}>
												<p>All</p>
											</DropdownItem>

											<DropdownItem
												onClick={() => handleUpdateAuditStatus("SUBMITTED")}
											>
												Submitted
											</DropdownItem>
											<DropdownItem
												onClick={() => handleUpdateAuditStatus("NOT_SUBMITTED")}
											>
												Not Submitted
											</DropdownItem>
										</DropdownMenu>
									</UncontrolledDropdown>
								</div>
							</div>
							<div>
								<h6 className="uploaded-details-wrapper__dropdown-title">
									Legislation
								</h6>
								<div className="uploaded-details-wrapper__dropdown-button">
									{/* <InputField
											inputType="INPUT_REACT_SELECT"
											placeholder="Choose Legislation"
											className="headcount-popup-wrapper__select"
											name="legislation_id"
											id="legislation_id"
											options={filteredLegislation}
											value={
												getValue(filteredLegislation, `length`, 0) > 0 &&
												filteredLegislation.filter(
													(item: object) =>
														getValue(item, `id`, "") ==
														getValue(params, `legislation_id`, "")
												)
											}
											onChange={(e: any) =>
												handleChangeFilter(
													"legislation_id",
													getValue(e, `id`, "")
												)
											}
											label="Country"
											isClear
										/> */}

									<SearchableDropdownSelect
										placeholder={"Search Legislation"}
										options={filteredLegislation}
										searchLoading={searchLoading}
										handleChange={(val: any) => handleTriggerAPI(val)}
										handleClick={(e: any) =>
											handleChangeFilter("legislation_id", e.id)
										}
										value={
											getValue(filteredLegislation, `length`, 0) > 0 &&
											filteredLegislation.filter(
												(item: object) =>
													getValue(item, `id`, "") ==
													getValue(params, `legislation_id`, "")
											)[0]
										}
										label="label"
										id="id"
										name="Legislation"
									/>
								</div>
							</div>
							<div className="button-wrapper d-flex align-items-center gap">
								{/* {
									getValue(mainParams,`listenable`,'') === '0'?
									
									<button
										className="common-button"
										disabled={
											getValue(mainParams,`listenable`,'') === '0'||
											getValue(selectedIndex, `length`, 0) !== 1 ||
											getValue(selectedIndex, `length`, 0) === 0 ||
											getValue(enableCopy, `[${0}].documents.length`, 0) == 0
										}
									>
										{
										getValue(mainParams,`listenable`,'') === '0'||
										getValue(selectedIndex, `length`, 0) !== 1 ||
										getValue(selectedIndex, `length`, 0) === 0 ||
										getValue(enableCopy, `[${0}].documents.length`, 0) == 0 ? (
											<img
												src="/images/content-copy-white.svg"
												className="img-fluid mr-2"
											/>
										) : (
											<img
												src="/images/content-copy.svg"
												className="img-fluid mr-2"
											/>
										)}
										Copy Document
									</button>
								:
								
								<NavLink
									to={`/checkpoint/details/copy-documents/${mainParams.id}/${
										mainParams.date
									}/${mainParams.code}/${getValue(
										selectedIDforCheckpoint,
										`[${0}].checkpoint.id`,
										""
									)}/${getValue(selectedIDforCheckpoint, `[${0}].id`, "")}/${getValue(mainParams,`listenable`,'')}`}
								>
									<button
										className="common-button"
										disabled={
											getValue(selectedIndex, `length`, 0) !== 1 ||
											getValue(selectedIndex, `length`, 0) === 0 ||
											getValue(enableCopy, `[${0}].documents.length`, 0) == 0
										}
									>
										{getValue(selectedIndex, `length`, 0) !== 1 ||
										getValue(selectedIndex, `length`, 0) === 0 ||
										getValue(enableCopy, `[${0}].documents.length`, 0) == 0 ? (
											<img
												src="/images/content-copy-white.svg"
												className="img-fluid mr-2"
											/>
										) : (
											<img
												src="/images/content-copy.svg"
												className="img-fluid mr-2"
											/>
										)}
										Copy Document
									</button>
								</NavLink>} */}
								{/* {!checkUploaded || getValue(checkUploaded, `length`, 0) > 0 ? (
									<button
										className="common-button"
										disabled={
											!checkUploaded || getValue(checkUploaded, `length`, 0) > 0
										}
									>
										<img
											src="/images/bulk-upload-white.svg"
											className="img-fluid"
										/>
										Bulk Upload
									</button>
								) : ( */}
								{/* {getValue(mainParams,`listenable`,'') === '0'?
								<button
								className="common-button"
								disabled
								// onClick={() => handleUploadDocument()}
							>
								<img src="/images/bulk-upload.svg" className="img-fluid" />
								Bulk Upload
							</button>:
								<NavLink
									to={`/checkpoint/details/bulk-upload/${mainParams.id}/${mainParams.date}/${mainParams.code}/${getValue(mainParams,`listenable`,'')}`}
								>
									<button
										className="common-button"
										// onClick={() => handleUploadDocument()}
									>
										<img src="/images/bulk-upload.svg" className="img-fluid" />
										Bulk Upload
									</button>
								</NavLink>} */}
								{/* )} */}

								{submitLoading ? (
									<button className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center">
										<img src="/images/white-check.svg" className="img-fluid" />
										Please wait...
									</button>
								) : checkSubmit.length === selectedIndex.length ? (
									<button
										className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center"
										onClick={handleModal2}
										disabled={
											selectedIndex.length === 0 ||
											getValue(mainParams, `listenable`, "") === "0"
										}
									>
										<img src="/images/white-check.svg" className="img-fluid" />
										Submit for Audit Review
									</button>
								) : (
									<button
										className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center"
										onClick={handleModal2}
										disabled
									>
										<img src="/images/white-check.svg" className="img-fluid" />
										Submit for Audit Review
									</button>
								)}
							</div>
						</div>
					</div>
					<div>
						{/*  --------------------------------------------- Sticky Header Starts ------------------------------------------------ */}
						<div
							className={`${
								classes === "is-sticky" ? "navHideShow" : "d-none"
							}`}
						>
							<section className="navigation-bar-wrapper">
								<div className="d-flex align-items-center justify-content-between">
									<div></div>
									<div className="d-flex" style={{ alignItems: "center" }}>
										{/* {getValue(mainParams, `listenable`, "") === "0" ? (
											<button
												style={{ marginRight: "10px" }}
												className="common-button"
												disabled={
													getValue(mainParams, `listenable`, "") === "0" ||
													getValue(selectedIndex, `length`, 0) !== 1 ||
													getValue(selectedIndex, `length`, 0) === 0 ||
													getValue(enableCopy, `[${0}].documents.length`, 0) ==
														0
												}
											>
												{getValue(mainParams, `listenable`, "") === "0" ||
												getValue(selectedIndex, `length`, 0) !== 1 ||
												getValue(selectedIndex, `length`, 0) === 0 ||
												getValue(enableCopy, `[${0}].documents.length`, 0) ==
													0 ? (
													<img
														src="/images/content-copy-white.svg"
														className="img-fluid mr-2"
													/>
												) : (
													<img
														src="/images/content-copy.svg"
														className="img-fluid mr-2"
													/>
												)}
												Copy Document
											</button>
										) : (
											<NavLink
												to={`/checkpoint/details/copy-documents/${
													mainParams.id
												}/${mainParams.date}/${mainParams.code}/${getValue(
													selectedIDforCheckpoint,
													`[${0}].checkpoint.id`,
													""
												)}/${getValue(
													selectedIDforCheckpoint,
													`[${0}].id`,
													""
												)}/${getValue(mainParams, `listenable`, "")}`}
											>
												<button
													className="common-button"
													disabled={
														getValue(selectedIndex, `length`, 0) !== 1 ||
														getValue(selectedIndex, `length`, 0) === 0 ||
														getValue(
															enableCopy,
															`[${0}].documents.length`,
															0
														) == 0
													}
													style={{ marginRight: "10px" }}
												>
													{getValue(selectedIndex, `length`, 0) !== 1 ||
													getValue(selectedIndex, `length`, 0) === 0 ||
													getValue(enableCopy, `[${0}].documents.length`, 0) ==
														0 ? (
														<img
															src="/images/content-copy-white.svg"
															className="img-fluid mr-2"
														/>
													) : (
														<img
															src="/images/content-copy.svg"
															className="img-fluid mr-2"
														/>
													)}
													Copy Document
												</button>
											</NavLink>
										)}

										{getValue(mainParams, `listenable`, "") === "0" ? (
											<button
												className="common-button"
												disabled
												style={{ marginRight: "10px" }}
											>
												<img
													src="/images/bulk-upload.svg"
													className="img-fluid"
												/>
												Bulk Upload
											</button>
										) : (
											<NavLink
												to={`/checkpoint/details/bulk-upload/${mainParams.id}/${
													mainParams.date
												}/${mainParams.code}/${getValue(
													mainParams,
													`listenable`,
													""
												)}`}
											>
												<button
													className="common-button"
													// onClick={() => handleUploadDocument()}
													style={{ marginRight: "10px" }}
												>
													<img
														src="/images/bulk-upload.svg"
														className="img-fluid"
													/>
													Bulk Upload
												</button>
											</NavLink>
										)} */}

										{submitLoading ? (
											<button className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center">
												<img
													src="/images/white-check.svg"
													className="img-fluid"
												/>
												Please wait...
											</button>
										) : checkSubmit.length === selectedIndex.length ? (
											<button
												className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center"
												style={{ border: "1px solid white" }}
												onClick={handleModal2}
												disabled={
													selectedIndex.length === 0 ||
													getValue(mainParams, `listenable`, "") === "0"
												}
											>
												<img
													src="/images/white-check.svg"
													className="img-fluid"
												/>
												Submit for Audit Review
											</button>
										) : (
											<button
												className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center"
												onClick={handleModal2}
												disabled
											>
												<img
													src="/images/white-check.svg"
													className="img-fluid"
												/>
												Submit for Audit Review
											</button>
										)}
									</div>
								</div>
							</section>
						</div>

						{/*  ----------------------------------------------- Sticky Header Ends ------------------------------------------------- */}

						<div className="uploaded-details-wrapper__header uploaded-details-wrapper__header-checkpoint  d-flex">
							<div className="uploaded-details-wrapper-form-group form-group">
								<label
									className="m-0 position-relative"
									htmlFor="header-checkbox"
								>
									<input
										type="checkbox"
										className="default-checkbox"
										id="header-checkbox"
										onChange={() =>
											handleChangeAllLocations(
												all === "true" ? "false" : "true"
											)
										}
										checked={
											locations.length === selectedIndex.length &&
											all === "true"
										}
									/>
									<div className="custom-checkbox">
										<img
											src="/images/uploaded-details/tick.svg"
											className="img-fluid uploaded-tick"
										/>
									</div>
								</label>
							</div>
							<div className="uploaded-details-wrapper__task-wrapper">
								<h6 className="uploaded-details-wrapper__header-title">
									Task ID
								</h6>
								<p className="uploaded-details-wrapper__header-text">
									Checkpoint ID
								</p>
							</div>
							<div className="uploaded-details-wrapper__legislation-wrapper">
								<h6 className="uploaded-details-wrapper__header-title">
									Form Name
								</h6>
								<p className="uploaded-details-wrapper__header-text">
									Compliance Activity
								</p>
							</div>
							<div className="uploaded-details-wrapper__status-wrapper">
								<h6 className="uploaded-details-wrapper__header-title">
									Upload Status
								</h6>
								<p className="uploaded-details-wrapper__header-text">
									Audit Status
								</p>
							</div>
							<div className="uploaded-details-wrapper__status-wrapper">
								<h6 className="uploaded-details-wrapper__header-title">Risk</h6>
							</div>
						</div>
					</div>
					{isLoading ? (
						<Loader />
					) : getValue(locations, `length`, 0) > 0 ? (
						locations.map((uploadDetailsObj: object, index: number) => {
							return (
								<div className="uploaded-details-wrapper__body-checkpoint-border uploaded-details-wrapper__header-checkpoint">
									<div
										className="uploaded-details-wrapper__body  uploaded-details-wrapper__body--checkpoint  d-flex"
										key={`details-${index}`}
									>
										<div className="uploaded-details-wrapper-form-group form-group">
											<label
												className="m-0 position-relative"
												htmlFor={`details-${index}`}
											>
												<input
													type="checkbox"
													className="default-checkbox"
													id={`details-${index}`}
													checked={selectedIndex.includes(
														getValue(uploadDetailsObj, `id`, "")
													)}
													onChange={() =>
														handleChangeCheckbox(
															getValue(uploadDetailsObj, `id`, "")
														)
													}
												/>
												<div className="custom-checkbox">
													<img
														src="/images/uploaded-details/tick.svg"
														className="img-fluid uploaded-tick"
													/>
												</div>
											</label>
										</div>
										<label
											className="uploaded-details-wrapper__task-wrapper cursor-pointer"
											htmlFor={`details-${index}`}
										>
											<h6 className="uploaded-details-wrapper__body-title">
												<span
													style={{ position: "relative" }}
													data-tip
													data-for="happyFace"
												>
													{getValue(uploadDetailsObj, `task_id`, "")}

													{parseInt(
														getValue(uploadDetailsObj, `submit_count`, 1)
													) > 1 && (
														<div
															style={{
																position: "absolute",
																height: "20px",
																width: "20px",
																borderRadius: "10px",
																backgroundColor: "#ff2d55",
																right: "-21px",
																top: "-6px",
															}}
															data-tip
															data-for="count"
														>
															<p
																style={{
																	color: "white",
																	textAlign: "center",
																	fontSize: "12px",
																	alignContent: "center",
																	marginTop: "3px",
																}}
															>
																{getValue(uploadDetailsObj, `submit_count`, "")}
															</p>
														</div>
													)}
												</span>
											</h6>
											<p className="uploaded-details-wrapper__body-text">
												{getValue(uploadDetailsObj, `checkpoint.form_no`, "")}
											</p>
											{/* <p className="uploaded-details-wrapper__body-text">
												{moment(
													getValue(uploadDetailsObj, `created_at`, "")
												).format("DD MMMM YYYY, hh:mm a")}
											</p> */}
										</label>
										<div className="uploaded-details-wrapper__legislation-wrapper">
											<h6 className="uploaded-details-wrapper__body-title">
												{getValue(
													uploadDetailsObj,
													`checkpoint.legislation.legislation_name`,
													""
												)}
											</h6>
											<p className="uploaded-details-wrapper__body-text">
												{getValue(
													uploadDetailsObj,
													`checkpoint.compliance_activity`,
													""
												)}
											</p>
										</div>
										<div className="uploaded-details-wrapper__status-wrapper">
											<h6
												className={`uploaded-details-wrapper__body-title uploaded-details-wrapper__body-title--${
													getValue(uploadDetailsObj, `upload_status`, "") ===
													"NOT_UPLOADED"
														? "red"
														: "green"
												}`}
											>
												{formatText(
													getValue(uploadDetailsObj, `upload_status`, "")
												)}
											</h6>
											<p
												className="uploaded-details-wrapper__body-text"
												style={{
													color:
														getValue(uploadDetailsObj, `audit_status`, "") ===
														"NON_COMPLIED"
															? "#d7242e"
															: "",
												}}
											>
												{formatText(
													getValue(uploadDetailsObj, `audit_status`, "")
												)}
											</p>
										</div>
										<div>
											<h6 className="uploaded-details-wrapper__body-title">
												{getValue(
													uploadDetailsObj,
													`checkpoint.impact_on_organization.text`,
													"-"
												)}
											</h6>
										</div>
										<div className="uploaded-details-wrapper__icons-wrapper">
											{getValue(uploadDetailsObj, `is_submitted`, "") ? (
												<div data-tip data-for="happyFace1">
													<img
														src="/images/audit-review/check-green.svg"
														className="img-fluid cursor-pointer"
														height={36}
														width={36}
													/>
												</div>
											) : (
												<div data-tip data-for="happyFace2">
													<img
														src="/images/audit-review/check-gray.svg"
														className="img-fluid cursor-pointer"
														height={36}
														width={36}
													/>
												</div>
											)}
											<ReactTooltip id="happyFace">
												<span>Submit Count</span>
											</ReactTooltip>
											<ReactTooltip id="happyFace1">
												<span>Submitted</span>
											</ReactTooltip>
											<ReactTooltip id="happyFace2">
												<span>Not Submitted</span>
											</ReactTooltip>
											<ReactTooltip id="happyFace3">
												<span>Comments</span>
											</ReactTooltip>
											<ReactTooltip id="happyFace4">
												<span>Upload</span>
											</ReactTooltip>
											<ReactTooltip id="happyFace5">
												<span>History</span>
											</ReactTooltip>
											<div data-tip data-for="happyFace3">
												<img
													src="/images/audit-review/mail.svg"
													className="img-fluid cursor-pointer"
													height={36}
													width={36}
													onClick={() =>
														getValue(mainParams, `listenable`, "") === "1"
															? handleModalComment(uploadDetailsObj)
															: ""
													}
												/>
											</div>
											<div data-tip data-for="happyFace4">
												<img
													src="/images/audit-review/upload.svg"
													className="img-fluid cursor-pointer"
													height={36}
													width={36}
													onClick={() =>
														getValue(mainParams, `listenable`, "") === "1"
															? handleModalUpload(uploadDetailsObj)
															: ""
													}
												/>
											</div>
											{/* <NavLink
												to={
													getValue(mainParams, `listenable`, "") === "1"
														? `/checkpoint/details/history/${mainParams.id}/${
																mainParams.date
														  }/${mainParams.code}/${getValue(
																uploadDetailsObj,
																`checkpoint.id`,
																""
														  )}/${getValue(mainParams, `listenable`, false)}`
														: window.location.pathname
												}
											>
												<div data-tip data-for="happyFace5">
													<img
														src="/images/audit-review/timer.svg"
														className="img-fluid cursor-pointer"
														height={36}
														width={36}
													/>
												</div>
											</NavLink> */}
										</div>
									</div>
									<div className="d-flex align-items-center gap mx-4">
										{getValue(uploadDetailsObj, `documents.length`, 0) > 0 &&
											getValue(uploadDetailsObj, `documents`, []).map(
												(items: object, ind: number) => {
													return (
														<div key={ind}>
															{getValue(items, `extension`, "") === ".pdf" ? (
																<div className="uploaded-details-wrapper__agreement d-flex align-items-center justify-content-between">
																	<img
																		src="/images/uploaded-details/pdf.svg"
																		className="img-fluid cursor-pointer"
																	/>
																	<p
																		className="uploaded-details-wrapper__agreement-text text-truncate cursor-pointer"
																		onClick={() =>
																			handleS3FileDownloadOnClick(
																				getValue(items, `key`, ""),
																				getValue(items, `name`, "")
																			)
																		}
																	>
																		{getValue(items, `name`, "")}
																	</p>
																	{
																		// getValue(
																		// 	uploadDetailsObj,
																		// 	`audit_status`,
																		// 	""
																		// ) !== "PENDING_AUDIT" &&
																		// 	getValue(
																		// 		uploadDetailsObj,
																		// 		`audit_status`,
																		// 		""
																		// 	) !== "COMPLIED" &&
																		// 	getValue(
																		// 		uploadDetailsObj,
																		// 		`audit_status`,
																		// 		""
																		// 	) !== "SUBMITTED" &&

																		// !getValue(
																		// 	uploadDetailsObj,
																		// 	`is_submitted`,
																		// 	false
																		// ) && (
																		<img
																			onClick={() =>
																				getValue(
																					mainParams,
																					`listenable`,
																					""
																				) === "1"
																					? handleDeleteFile(
																							getValue(
																								uploadDetailsObj,
																								`id`,
																								""
																							),
																							getValue(items, `id`, "")
																					  )
																					: ""
																			}
																			src="/images/uploaded-details/close-grey.svg"
																			className="img-fluid cursor-pointer"
																		/>
																		// )
																	}
																</div>
															) : (
																<div className="uploaded-details-wrapper__agreement d-flex align-items-center justify-content-between">
																	<img
																		// onClick={() =>
																		// 	handleDeleteFile(
																		// 		getValue(uploadDetailsObj, `id`, ""),
																		// 		getValue(items, `id`, "")
																		// 	)
																		// }
																		src="/images/uploaded-details/word.svg"
																		className="img-fluid cursor-pointer"
																	/>
																	<p
																		className="uploaded-details-wrapper__agreement-text text-truncate cursor-pointer"
																		onClick={() =>
																			handleS3FileDownloadOnClick(
																				getValue(items, `key`, ""),
																				getValue(items, `name`, "")
																			)
																		}
																	>
																		{getValue(items, `name`, "")}
																	</p>
																	{
																		// !getValue(
																		// 	uploadDetailsObj,
																		// 	`is_submitted`,
																		// 	false
																		// ) && (
																		<img
																			onClick={() =>
																				getValue(
																					mainParams,
																					`listenable`,
																					""
																				) === "1"
																					? handleDeleteFile(
																							getValue(
																								uploadDetailsObj,
																								`id`,
																								""
																							),
																							getValue(items, `id`, "")
																					  )
																					: ""
																			}
																			src="/images/uploaded-details/close-grey.svg"
																			className="img-fluid cursor-pointer"
																		/>
																		// )
																	}
																</div>
															)}
														</div>
													);
												}
											)}
									</div>
								</div>
							);
						})
					) : (
						<>
							{Object.keys(params).length !== 0 ? <Notfound /> : <Notfound />}
						</>
					)}
					<div className="pagination-wrapper mb-3">
						{totalCount > 100 ? (
							<PaginationPage
								totalCount={totalCount}
								limit={limit}
								pageNumber={page_no}
								handleChangePagination={handleChangePagination}
								handleChangeLimit={handleChangeLimit}
							/>
						) : (
							<p className="show-rows-count mt-3 d-flex">
								Total Count:&nbsp;&nbsp;{" "}
								<p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
							</p>
						)}
					</div>
					{isOpen && (
						<CommentsModal
							{...props}
							isOpen={isOpen}
							handleModal={handleModalCommentCancel}
							vendorInfo={vendorInfo}
							edit={true}
						/>
					)}
					{isOpen1 && (
						<UploadModal
							{...props}
							isOpen={isOpen1}
							handleModal={handleModalUploadCancel}
							vendorInfo={vendorInfo}
							getData={getDataRefetch}
							mainParams={mainParams}
							getDashboardInfo={getDashboardInfo}
						/>
					)}
					{isOpen2 && (
						<Modal
							isOpen={isOpen2}
							toggle={() => handleModal2()}
							centered
							size="lg"
						>
							<div className="d-flex justify-content-between m-3">
								<div>
									<h3>Add Comments</h3>
								</div>
								<div>
									<img
										src="/images/close-black.svg"
										className="img-fluid cursor-pointer"
										onClick={handleModal2}
									/>
								</div>
							</div>
							<ModalBody>
								<div className="m-4">
									<InputField
										inputType="TEXTAREA"
										value={comments}
										onChange={(e: any) => setComments(e.target.value)}
										rows="10"
										placeholder="Add Comment"
									/>
								</div>
							</ModalBody>
							<div className="d-flex justify-content-end m-3">
								<button
									className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
									onClick={() => handleModal2()}
								>
									Close
								</button>
								{submitLoading ? (
									<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
										Please wait...
									</button>
								) : (
									<button
										className="ascent-button ascent-button--header-buttons ascent-button--secondary"
										onClick={handleSubmitTask}
									>
										Submit
									</button>
								)}
							</div>
						</Modal>
					)}
				</div>
				<br />
				<br />
				{/* <div className="w-100">
					{locations.length > 0 && (
						<img src="/images/footer.svg" className="img-fluid" />
					)}
				</div> */}
			</div>
			<DeleteModal
				isOpen={isDelete}
				handleModal={handleDelete}
				handleSubmit={handleDeleteFunction}
				deleteValue={""}
			/>
		</>
	);
};
